import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class PostReferral {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * PostReferral constructor.
     *
     * @param {ApiService|null} apiService
     *
     * @returns {void}
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    /**
     * Send email and name to backend.
     *
     * @param {String} name
     * @param {String} email
     *
     * @returns {Promise}
     */
    handle(name, email, giftnote) {
        return this.apiService
            .post(ApiEndpoints['users.referral.store'], {
                recipient_name: name,
                recipient_email: email,
                recipient_giftnote: giftnote,

            });
    }
}
